
























































































































import { Vue, Component, Prop, Watch } from 'vue-property-decorator';
import { portfolioInfoCloumns, peopleColumns } from '@/utils/finance';
import { portfolioQuery, savePortfolio, getDetail, editBase } from '@/api/project';
import { getCommonList } from '@/api/common';
import selectMember from '@/components/project/selectMember.vue';
import store from '@/store';
import { hasPermission } from '@/utils/utils';

@Component({
  components: { selectMember }
})
class PortfolioInfo extends Vue {
  @Prop()
  projectId;

  portfolioInfoCloumns: any[] = portfolioInfoCloumns;
  peopleColumns: any[] = peopleColumns;
  portfolioInfo: any[] = [];
  industryList: any[] = [];
  portfolioData: any = {};
  portfolioForm: any = {};
  portfolioDialogVisible: boolean = false;
  peopleDialogVisible: boolean = false;
  peopleData: any[] = [];
  baseInfo: any = {};
  sourceInsideIds: any[] = [];
  sourceOutsideDesc: string = '';
  portfolioPermission: boolean = false;
  basePermission: boolean = false;
  showBase: boolean = true;
  showPortfolio: boolean = true;
  mounted() {
    this.getPermissions();
  }

  @Watch('projectId')
  async valueChange() {
    this.fetchBaseInfo();
    try {
      await this.getIndustryList();
    } catch (err) {
      console.log(err);
    }
    this.fetchPortfolioInfo();
  }

  get btnPermission() {
    try {
      const userInfo = this.$store.getters.userInfo;
      const pageInfo = userInfo.permissions.filter(item => item.fullPath === '/project');
      const actions = pageInfo[0].children.filter(item => item.type === 1).map(item => item.value);
      return actions;
    } catch (error) {
      return [];
    }
  }

  getPermissions() {
    const queue = [...store.getters.userInfo.permissions];
    this.basePermission = hasPermission(queue, '/project/info/baseEdit');
  }

  async fetchPortfolioInfo() {
    try {
      let res = await portfolioQuery({ companyId: this.projectId }, false);
      if (res.code === 403) {
        this.showPortfolio = false;
      } else if (res.code === 200) {
        let {
          oldName,
          lpName,
          lpEnName,
          sccAboutName,
          sccCompanyName,
          industry,
          industryFiveFund,
          industryFiveFundEn,
          description,
          descriptionEn,
          sccDetail,
          remark,
          ourBoardPerson,
          ourBoardPersonEn
        } = res.data;
        let industryInfo = this.industryList.find(e => {
          return e.id === industry;
        });
        let industryName, industryEnName;
        if (industryInfo) {
          industryName = industryInfo.name;
          industryEnName = industryInfo.enName;
        }
        this.portfolioData = {
          oldName,
          lpName,
          lpEnName,
          sccAboutName,
          sccCompanyName,
          industry,
          industryFiveFund,
          industryFiveFundEn,
          description,
          descriptionEn,
          sccDetail,
          remark,
          industryEnName,
          ourBoardPerson,
          ourBoardPersonEn
        };
        this.portfolioInfo = [
          {
            language: '中文',
            name: lpName,
            industry: industryName,
            industryFiveFund: industryFiveFund,
            description: description,
            ourBoardPerson: ourBoardPerson
          },
          {
            language: '英文',
            name: lpEnName,
            industry: industryEnName,
            industryFiveFund: industryFiveFundEn,
            description: descriptionEn,
            ourBoardPerson: ourBoardPersonEn
          }
        ];
      } else {
        this.$message.error(res.msg);
      }
    } catch (err) {
      console.log(err);
    }
  }

  async getIndustryList() {
    try {
      const res = await getCommonList();
      if (res.code === 200) {
        this.industryList = res.data.industry;
      }
    } catch (err) {
      console.log(err);
    }
  }

  fetchBaseInfo() {
    getDetail(this.projectId, false).then(res => {
      if (res.code === 403) {
        this.showBase = false;
      } else {
        let data = res.data;
        let { base = {} } = data;
        this.baseInfo = base;
        let { sourceInsideIds = [], sourceOutsideDesc = '' } = base;
        this.sourceInsideIds = sourceInsideIds;
        this.sourceOutsideDesc = sourceOutsideDesc;
        this.peopleData = [
          {
            sourceInsideIds: (sourceInsideIds[0] && sourceInsideIds[0].nickname) || '',
            sourceOutsideDesc
          }
        ];
      }
    });
  }

  portfolioEdit() {
    this.portfolioDialogVisible = true;
    this.portfolioForm = {
      ...this.portfolioData
    };
  }
  peopleEdit() {
    let { sourceInsideIds = [], sourceOutsideDesc = '' } = this.baseInfo;
    this.sourceInsideIds = sourceInsideIds;
    this.sourceOutsideDesc = sourceOutsideDesc;
    this.peopleDialogVisible = true;
  }

  handleIndustryChange(index) {
    let industry = this.industryList.find(e => {
      return e.id === index;
    });
    this.portfolioForm.industryEnName = industry.enName;
  }

  cancelPortfolio() {
    this.portfolioDialogVisible = false;
  }

  async savePortfolio() {
    try {
      let { portfolioForm, projectId } = this;
      let data = {
        ...portfolioForm,
        companyId: projectId
      };
      let res = await savePortfolio(data);
      if (res.code === 200) {
        //保存成功
        this.$message.success('保存成功');
        this.portfolioDialogVisible = false;
        this.fetchPortfolioInfo();
      } else {
        this.$message.error(res.msg);
      }
    } catch (err) {
      console.log(err);
    }
  }
  choseUserIds(val) {
    this.sourceInsideIds = val;
  }

  delUserIds(user) {
    this.sourceInsideIds = this.sourceInsideIds.filter(_user => _user.id !== user.id);
  }

  savePeople() {
    let sourceInsideIds = (this.sourceInsideIds || []).map(item => item.id).join(',');
    editBase({
      ...this.baseInfo,
      id: this.projectId,
      sourceInsideIds,
      sourceOutsideDesc: this.sourceOutsideDesc
    }).then(res => {
      if (res.code === 200) {
        this.$message.success('保存成功');
        this.peopleDialogVisible = false;
        this.fetchBaseInfo();
      }
    });
  }

  cancelPeople() {
    this.peopleDialogVisible = false;
  }
}

export default PortfolioInfo;
